interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-100 px-4 text-center text-slate-700 dark:bg-slate-950 dark:text-slate-300"
      role="status"
      aria-live="polite"
    >
      <div
        className="h-12 w-12 animate-spin motion-reduce:animate-none rounded-full border-4 border-slate-200 border-t-slate-600 dark:border-slate-800 dark:border-t-slate-400"
        aria-hidden
      />
      {message ? <p className="text-base font-semibold">{message}</p> : null}
    </div>
  );
}
